<template>
  <div class="wholeContext">
    <div class="appContext">
      <div class="scarListWrap">
        <input type="file" @change="onFileChange" multiple="" class="boneImg"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import errorParser from '@/utils/error-parser'

export default {
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'UPLOARD_SCAR_IMAGE'
    ]),
    async onFileChange () {
      const formData = new FormData()
      const imagefile = document.querySelector('.boneImg')
      formData.append('image', imagefile.files[0])
      try {
        const requestData = {
          scarInfoCode: 1,
          photo: formData,
          afterMonth: 1,
          photoDate: '2020-05-23'
        }
        console.log('ㅇㅇ', requestData)
        await this.UPLOARD_SCAR_IMAGE(requestData)
          .then(() => {
          })
      } catch (error) {
        console.log('error :', error);
        console.log('흉터관리 이미지 업로드 api에서 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    }
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
</style>
